import React from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
const { FiCalendar, FiChevronRight, FiMessageSquare } = FiIcons;
import { format } from 'date-fns';

export default function LeadCard({ lead, onClick }) {
  return (
    <div 
      onClick={onClick} 
      className="bg-white border border-slate-100 rounded-3xl p-6 active:scale-[0.98] transition-all cursor-pointer shadow-sm relative overflow-hidden group"
    >
      <div className="flex justify-between items-start mb-5">
        <div className="flex items-center gap-4">
          <div className="w-12 h-12 rounded-[1.25rem] bg-slate-50 border border-slate-100 flex items-center justify-center text-brand-blue group-hover:bg-brand-blue group-hover:text-white transition-colors duration-300">
            <span className="font-black text-sm">{(lead.name || 'A').charAt(0).toUpperCase()}</span>
          </div>
          <div>
            <h4 className="font-black text-slate-900 text-base leading-none tracking-tight">{lead.name || 'Anonymous'}</h4>
            <div className="flex items-center gap-2 mt-2">
              <SafeIcon icon={FiCalendar} className="text-slate-300 text-[10px]" />
              <span className="text-[10px] text-slate-400 uppercase font-black tracking-widest">
                {lead.created_at ? format(new Date(lead.created_at), 'dd MMM • h:mm a') : 'Unknown'}
              </span>
            </div>
          </div>
        </div>
        <div className="w-8 h-8 rounded-full bg-slate-50 flex items-center justify-center text-slate-300 group-hover:text-brand-blue transition-colors">
          <SafeIcon icon={FiChevronRight} className="text-lg" />
        </div>
      </div>

      <div className="space-y-4">
        <div className="flex flex-col gap-1">
          <span className="text-[10px] font-black uppercase tracking-widest text-slate-300">Contact Point</span>
          <span className="text-xs font-bold text-slate-600 truncate">{lead.email || 'Private Email'}</span>
        </div>

        <div className="bg-slate-50 rounded-2xl p-4 border border-slate-100 relative">
          <div className="absolute top-2 right-2 opacity-10">
            <SafeIcon icon={FiMessageSquare} className="text-lg" />
          </div>
          <p className="text-xs text-slate-500 italic line-clamp-2 leading-relaxed font-medium">
            "{lead.message || 'No enquiry message provided'}"
          </p>
        </div>
      </div>
      
      <div className="mt-4 flex items-center justify-between">
        <span className="px-2.5 py-1 bg-brand-blue/5 text-brand-blue rounded-lg text-[9px] font-black uppercase tracking-wider">
          {lead.utm_source || 'Direct Source'}
        </span>
        <div className="flex gap-1.5">
          <div className={`w-1.5 h-1.5 rounded-full ${lead.business_email_sent ? 'bg-emerald-400' : 'bg-slate-200'}`}></div>
          <div className={`w-1.5 h-1.5 rounded-full ${lead.sms_sent ? 'bg-emerald-400' : 'bg-slate-200'}`}></div>
        </div>
      </div>
    </div>
  );
}